import React, { useId } from 'react';

/**
 * The tone3000 verified check (`components/icons/Varified.tsx` there): three
 * offset strokes in the brand red / yellow / blue. Mask ids are per instance
 * so several badges can share a page.
 */
export const VerifiedBadge: React.FC<{ size?: number; className?: string }> = ({
  size = 20,
  className = '',
}) => {
  const id = useId();
  const m1 = `t3k-v1-${id}`;
  const m2 = `t3k-v2-${id}`;
  const m3 = `t3k-v3-${id}`;
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 32 33'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      style={{ shapeRendering: 'geometricPrecision', overflow: 'visible' }}
      aria-hidden='true'
    >
      <mask id={m1} fill='white'>
        <path d='M30 9.91187L10.75 32.5001L2 21.2327' />
      </mask>
      <path
        d='M33.8055 13.155C35.5967 11.0533 35.3449 7.89746 33.2431 6.10633C31.1414 4.3152 27.9856 4.567 26.1945 6.66874L33.8055 13.155ZM10.75 32.5001L6.80094 35.5669C7.72366 36.755 9.13231 37.4646 10.6363 37.4988C12.1403 37.533 13.5798 36.8882 14.5555 35.7432L10.75 32.5001ZM5.94906 18.166C4.25534 15.985 1.11425 15.5899 -1.06675 17.2837C-3.24775 18.9774 -3.64278 22.1185 -1.94906 24.2995L5.94906 18.166ZM26.1945 6.66874L6.94446 29.257L14.5555 35.7432L33.8055 13.155L26.1945 6.66874ZM14.6991 29.4334L5.94906 18.166L-1.94906 24.2995L6.80094 35.5669L14.6991 29.4334Z'
        fill='#0000FF'
        mask={`url(#${m1})`}
      />
      <mask id={m2} fill='white'>
        <path d='M30 0.500122L10.75 23.0884L2 11.821' />
      </mask>
      <path
        d='M33.8055 3.74325C35.5967 1.64151 35.3449 -1.51428 33.2431 -3.30541C31.1414 -5.09655 27.9856 -4.84475 26.1945 -2.74301L33.8055 3.74325ZM10.75 23.0884L6.80094 26.1551C7.72366 27.3433 9.13231 28.0529 10.6363 28.0871C12.1403 28.1213 13.5798 27.4765 14.5555 26.3315L10.75 23.0884ZM5.94906 8.75423C4.25534 6.57323 1.11425 6.17821 -1.06675 7.87193C-3.24775 9.56565 -3.64278 12.7067 -1.94906 14.8877L5.94906 8.75423ZM26.1945 -2.74301L6.94446 19.8452L14.5555 26.3315L33.8055 3.74325L26.1945 -2.74301ZM14.6991 20.0216L5.94906 8.75423L-1.94906 14.8877L6.80094 26.1551L14.6991 20.0216Z'
        fill='#FF0000'
        mask={`url(#${m2})`}
      />
      <mask id={m3} fill='white'>
        <path d='M30 5.20599L10.75 27.7942L2 16.5269' />
      </mask>
      <path
        d='M33.8055 8.44912C35.5967 6.34738 35.3449 3.19159 33.2431 1.40046C31.1414 -0.390674 27.9856 -0.138876 26.1945 1.96286L33.8055 8.44912ZM10.75 27.7942L6.80094 30.861C7.72366 32.0492 9.13231 32.7587 10.6363 32.7929C12.1403 32.8272 13.5798 32.1824 14.5555 31.0374L10.75 27.7942ZM5.94906 13.4601C4.25534 11.2791 1.11425 10.8841 -1.06675 12.5778C-3.24775 14.2715 -3.64278 17.4126 -1.94906 19.5936L5.94906 13.4601ZM26.1945 1.96286L6.94446 24.5511L14.5555 31.0374L33.8055 8.44912L26.1945 1.96286ZM14.6991 24.7275L5.94906 13.4601L-1.94906 19.5936L6.80094 30.861L14.6991 24.7275Z'
        fill='#FFFF00'
        mask={`url(#${m3})`}
      />
    </svg>
  );
};
